export enum ErrorCode {
  RejectedBlank = 'RejectedBlank',
  NameNotUnique = 'NameNotUnique',
  MockupConfigurationMatches = 'MockupConfigurationMatches'
}

export enum ErrorLevel {
  Mandatory = 'Mandatory',
  NotMandatory = 'NotMandatory'
}
